import release from './version.json';

export const FE_VERSION = release.version;
